import React from "react";
import "./FabButton.css";

type FabButtonProps = {
  onClick: () => void;
  imageUrl: string;
  altText: string;
};

const FabButton: React.FC<FabButtonProps> = ({
  onClick,
  imageUrl,
  altText,
}) => {
  return (
    <button className="fab-button" onClick={onClick}>
      <img src={imageUrl} alt={altText} />
    </button>
  );
};

export default FabButton;
